import Header from "./Header";
import React, {useState} from "react";
import Footer from "./Footer";
import {sendFeedback} from "../service/FormService";
import {isUserLoggedIn} from "../service/AuthService";
import Loading from "./Loading";
import {feedbackMap} from "../constants/Constants";

const selectOptions = {
    clarity: ["very unclear", "somewhat unclear", "somewhat clear", "very clear"],
    mostValuable: ["Novelty", "Impact", "Methodology", "All equally valuable"],
    howOften: ["Daily", "Weekly", "Monthly", "Rarely", "Never"],
    // useAgain: ["Yes", "No", "Maybe"],
};

const fieldTypes = {
    clarity: "select",
    mostValuable: "select",
    howOften: "select",
    // useAgain: "select",
};

function Feedback() {
    const [formData, setFormData] = useState({
        title: "",
        clarity: "",
        mostValuable: "",
        tools: "",
        howOften: "",
        useAgain: "",
        improvements: "",
        name: "",
        followUpEmail: "",
    });

    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);
    const [error, setError] = useState(false);

    function handleChange(e, key) {
        setFormData({...formData, [key]: e.target.value});
    }

    function handleSubmit(e) {
        e.preventDefault();
        setLoading(true);
        setError(false);
        setSent(false);
        sendFeedback(formData, true)
            .then((response) => {
                if (response.success === true) {
                    setSent(true);
                } else {
                    setError(true);
                }
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
                setError(true);
            });
    }

    return (
        <div>
            <Header page={"feedback"}/>

            {loading ? (
                <Loading/>
            ) : (
                <div className="body">
                    {sent ? (
                        <div>
                            <br/>
                            <div className="sub-heading">Thank you! Your feedback has been submitted.</div>
                        </div>
                    ) : (
                        <form onSubmit={handleSubmit} className="research-form">
                            <h5 className="sub-heading">Send Us Feedback</h5>
                            {error ?
                                <div className={"score-submitted-text"} style={{border: '2px solid red'}}>There was
                                    an error
                                    submitting your feedback. Please try again.
                                </div>
                                :
                                null
                            }
                            {Object.keys(feedbackMap).map(key => (
                                <div key={key} className="feedback-field">
                                    <label className="research-form-label">{feedbackMap[key]}</label>

                                    {fieldTypes[key] === "select" ? (
                                        <select
                                            className="research-form-input margin-bottom-3-4-rem"
                                            value={formData[key]}
                                            onChange={(e) => handleChange(e, key)}
                                            required
                                        >
                                            <option value="">Select an option</option>
                                            {selectOptions[key].map(opt => (
                                                <option key={opt} value={opt}>{opt}</option>
                                            ))}
                                        </select>
                                    ) : (
                                        <div className="textarea-wrapper margin-bottom-1-rem">
                                            <textarea
                                                className={`research-form-input ${
                                                    key !== "name"
                                                        ? "margin-bottom-neg-1-half-rem"
                                                        : "margin-bottom-neg-1-rem"
                                                }`}
                                                value={formData[key]}
                                                onChange={(e) => handleChange(e, key)}
                                                placeholder={key === "name" ? "Name" : key === "followUpEmail" ? "Email" : "Enter your response..."}
                                                rows={key === "title" || key === "name" || key === "followUpEmail" ? 1 : 3}
                                                maxLength={key !== "followUp" && key !== "followUpEmail" ? 1000 : 100}
                                                required={key !== "name" && key !== "followUpEmail"} // ✅ conditional required
                                            />
                                            <div className="char-count">
                                                {key !== "name" && key !== "followUpEmail" && `${formData[key]?.length || 0}/1000`}
                                            </div>

                                        </div>

                                    )}
                                </div>
                            ))}

                            <br/>
                            <button type="submit" className="submit">Submit</button>
                            {error && (
                                <div className="error">Something went wrong. Please try again.</div>
                            )}
                        </form>
                    )}
                </div>
            )}
        </div>
    );
}

export default Feedback;
